// extracted by mini-css-extract-plugin
export default {"Highlight":"Card_Highlight__ENGy2","Selected":"Card_Selected__kAbs5"};